import { getNormalisedPerformanceFFs } from '@atlassian/jira-common-long-task-metrics/src/common/util/collectors.tsx';
import { issueViewOpenInteraction } from '../utils/performance-analytics/index.tsx';
import type { BoardCardCount } from './board-data-collector.tsx';

export const setIssueViewOpenFeedbackMark = () => {
	issueViewOpenInteraction.mark('feedback');
};

export const setIssueViewOpenFinishMark = (
	isSideBar: boolean,
	boardCardCount: BoardCardCount,
	isCMPBoard: boolean,
) =>
	issueViewOpenInteraction.stop({
		customData: {
			...getNormalisedPerformanceFFs(),
			...boardCardCount,
			isSideBar,
			isClassic: isCMPBoard,
		},
	});
